import { type App } from 'vue'

interface DMCoreConfigPluginOptions {
  appName?: 'pos' | 'ssbt-bo'
  getTenantUuid: () => string
  getDeviceUuid: () => string
}

export const dmCoreConfig: Partial<DMCoreConfigPluginOptions> = {}

export default {
  install(_app: App, options: DMCoreConfigPluginOptions) {
    dmCoreConfig.appName = options.appName
    dmCoreConfig.getTenantUuid = options.getTenantUuid
    dmCoreConfig.getDeviceUuid = options.getDeviceUuid
  }
}
